module.exports = __webpack_public_path__ + "img/hand-fingers-crossed.d58f1462.svg";